import { gql } from "@apollo/client";

export const UpdateGridAsset = gql`
    mutation UpdateGridAsset ($id: ID!, $input: GridAssetUpdateAttributesInput!){
        updateGridAsset(id: $id, input: $input) {
            id
            title
            visible
        }
    }
`;
